var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 66,
    viewBox: "0 0 298 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8836 17.1719H97.7274L96.0404 23.4152H79.1757L77.445 29.9311H92.26L90.573 36.082H75.7531L73.9299 42.8265H91.0696L89.3851 49.0699H65.3125L73.8836 17.1719Z",
    fill: "#1C2951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.241 17.1719H109.261L100.69 49.0699H93.6699L102.241 17.1719Z",
    fill: "#1C2951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85 49.6224C122.01 49.6206 120.181 49.3442 118.424 48.8025C116.672 48.2785 115.038 47.42 113.614 46.2745C112.168 45.0945 110.995 43.6174 110.171 41.9436C109.29 40.1982 108.85 38.1406 108.85 35.7708C108.845 33.2996 109.358 30.8548 110.354 28.5931C112.383 23.93 116.122 20.2209 120.802 18.2281C123.321 17.1466 126.038 16.603 128.779 16.632C130.311 16.618 131.84 16.7714 133.338 17.0894C134.597 17.3576 135.822 17.7657 136.99 18.3059C137.993 18.7673 138.933 19.3534 139.789 20.0505C140.545 20.6671 141.225 21.3702 141.817 22.1454L136.625 26.7488C135.645 25.6888 134.493 24.8027 133.217 24.1284C131.896 23.4146 130.232 23.0578 128.226 23.0578C126.582 23.0452 124.954 23.3949 123.46 24.0821C122.021 24.7414 120.721 25.6697 119.631 26.8169C118.543 27.9698 117.677 29.3135 117.077 30.7805C116.454 32.2902 116.137 33.9088 116.145 35.5421C116.123 36.676 116.34 37.802 116.783 38.8462C117.18 39.7656 117.78 40.5833 118.538 41.238C119.301 41.8877 120.183 42.3834 121.135 42.6978C122.155 43.0384 123.225 43.2086 124.3 43.2015C125.398 43.2187 126.493 43.0961 127.559 42.8365C128.397 42.6255 129.212 42.3354 129.994 41.9703L131.513 36.7732H124.453L126.094 30.7123H139.955L135.43 46.6127C133.788 47.5192 132.053 48.2452 130.254 48.7781C128.172 49.3695 126.014 49.6539 123.85 49.6224V49.6224Z",
    fill: "#1C2951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.237 17.1719H172.081L170.394 23.4152H153.524L151.794 29.9311H166.609L164.922 36.082H150.107L148.283 42.8265H165.426L163.739 49.0699H139.666L148.237 17.1719Z",
    fill: "#1C2951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.278 17.1719H182.751L192.052 37.4494L197.522 17.1719H204.452L195.881 49.0699H189.908L180.244 28.1452L174.645 49.0699H167.707L176.278 17.1719Z",
    fill: "#1C2951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.828 17.1719H216.304L225.603 37.4494L231.075 17.1719H238.003L229.432 49.0699H223.46L213.796 28.1452L208.197 49.0699H201.26L209.828 17.1719Z",
    fill: "#84C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.384 17.1719H267.24L265.553 23.4152H248.685L246.952 29.9311H261.748L260.061 36.082H245.253L243.43 42.8265H260.572L258.885 49.0699H234.812L243.384 17.1719Z",
    fill: "#84C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39 23.6488H266.68L268.413 17.1719H294.854L293.121 23.6415H283.413L276.573 49.0772H269.552L276.39 23.6488Z",
    fill: "#84C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4978 39.531C60.1065 24.9125 51.1755 10.1379 36.5499 6.53102C21.9243 2.92413 7.14262 11.8508 3.53399 26.4693C-0.0746314 41.0878 8.85636 55.8624 23.4819 59.4693C38.1075 63.0762 52.8892 54.1495 56.4978 39.531Z",
    fill: "#84C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7579 34.5574H27.2038C20.7993 34.5574 15.6094 32.156 15.6094 26.8007C15.6094 21.4479 20.7993 19.0439 27.2038 19.0439H45.7579",
    stroke: "#1C2951",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8119 42.1611H45.8436V49.9179H15.8119C14.7828 49.9179 13.7958 49.5093 13.0681 48.7819C12.3405 48.0546 11.9316 47.0681 11.9316 46.0395C11.9316 45.0109 12.3405 44.0244 13.0681 43.2971C13.7958 42.5697 14.7828 42.1611 15.8119 42.1611V42.1611Z",
    fill: "#1C2951"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogo);
export default __webpack_public_path__ + "static/media/navbar_logo.61dca558cef6cae7f1bde548224017f2.svg";
export { ForwardRef as ReactComponent };